import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import useAuth from './useAuth';

export default function useRegistration() {
    const { request } = useAuth(); // this wraps axios with auth headers
    const queryClient = useQueryClient();

    // Fetch Registartion Data
    const registrationQuery = useQuery({
        queryKey: ['registration'],
        queryFn: () => request.get('/registration').then((res) => res.data),
    });


    // Add Registration
    const addRegistrationMutation = useMutation({
        mutationFn: (data) => request.post('/registration', data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['registration'] });
        },
    });

    // Remove Registartion
    const removeRegistrationMutation = useMutation({
        mutationFn: (registrationId) => request.delete('/registration', { data: { registrationId } }),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['registration'] });
        },
    });


    return {
        // Queries
        registrationData: registrationQuery?.data?.registrationData || [],
        isLoadingRegistrationData: registrationQuery.isLoading,

        // Mutations
        addRegistartion: addRegistrationMutation.mutateAsync,
        isRegistering: addRegistrationMutation.isPending,
        removeRegistrationMutation: removeRegistrationMutation.mutateAsync,
        isRemovingRegistration: removeRegistrationMutation.isPending,
    };
}
